<script lang="ts">
  import { Col, Input, Row, Table } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { DefaultInputtext, InputHoverColor, InputHoverColorMessage } from "../../../../utils/Constant/Constant";
</script>
<Col sm="12">
    <Card headerTitle={"Input"}>
      <div slot="contentbody">
        <Row class="card-block row">
          <Col sm="12" lg="12" xl="12" >
            <div class="table-responsive">
              <Table bordered class="checkbox-td-width">
                <tbody>
                  <tr>
                    <td>{DefaultInputtext}</td>
                    <td class="w-50">
                      <Input class="input-primary" id="exampleFormControlInput1" type="email" placeholder="Input text" />
                    </td>
                    <td><span>{"Use for basic select control."}</span></td>
                  </tr>
                  <tr>
                    <td>{InputHoverColor} </td>
                    <td class="w-50">
                      <Input  id="exampleFormControlInput2" type="email" placeholder="Input text" />
                    </td>
                    <td><span>{@html InputHoverColorMessage}</span></td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
</Col>